import React from 'react'
import { Box, Text } from '@usap/uicomponents'
import { Heading5 } from '../../../../common/heading'
import { CommentBoxContainer, CommentTextArea } from "../style/CommentTextAreaWMO.css"

const CommentTextAreaWMO = props => {
  const {
    widgets,
    errorSteps,
    selectedPart,
    commentValueRef,
    handleChange,
    isDesktop
  } = props

  const requiredData = widgets.required
    ? ''
    : ' <span style="font-size: 16px; color: #5C5C5C; font-weight: 400">(Optional)</span>'

  const headerText = `${widgets.title}${requiredData}`

  return (
    <CommentBoxContainer>
      <Heading5
        width="large"
        title={headerText}
        color="dark-2"
        size={isDesktop ? '16px' : '14px'}
        style={{ fontWeight: 500, maxWidth: '100%' }}
        margin={{ bottom: '16px', top: '0px' }}
      />

      {widgets.subtitle && (
        <Box alignContent="start" alignSelf="start" margin="8px 0">
          <Text size="small" margin={{ left: 'xsmall' }}>
            {widgets.subtitle}
          </Text>
        </Box>
      )}

      <Text id={`error-${widgets.id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[widgets.id]}
      </Text>

      <Box
        direction="column"
        alignContent="start"
        alignSelf="start"
        margin={{ horizontal: '0', vertical: '0' }}
      >
        <Box height="72px" round="xsmall">
          <CommentTextArea
            fill
            id={`txt${selectedPart}`}
            name="message"
            overflow="auto"
            placeholder="Type your comment here"
            cols={
              widgets.props[1].id === 'max'
                ? widgets.props[1].value
                : widgets.props[0].value
            }
            rows={
              widgets.props[1].id === 'min'
                ? widgets.props[1].value
                : widgets.props[0].value
            }
            onChange={handleChange}
            ref={commentValueRef}
          />
        </Box>
      </Box>
    </CommentBoxContainer>
  )
}

export default CommentTextAreaWMO
